module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-3.0f2bd65a.jpg";